// The Daily Output guide (37_CapacityOutput.jsx · ModuleHelp, Max 01/11).
const en = {
  vendorT: 'Choose the vendor',
  vendorB: 'You are not tied to one vendor, so pick the one whose output you want to see or enter. A vendor account goes straight to its own sheet.',
  dayT: 'Pick the day',
  dayB: 'Output is kept one day at a time. Change the date here; next to it, Today jumps back, Sheets filled in lists the days that have a sheet, and Data check looks for odd figures.',
  sumT: 'The day at a glance',
  sumB: 'Pieces, rows and working hours added up for what the table shows. With a column filter on, it is only that part of the day.',
  toolsT: 'Edit, unmatched and reload',
  toolsB: 'Edit the table opens every cell for typing (if you may edit) and saves them together. Unmatched lists rows that could not be tied to an order. Reload reads the day again.',
  gridT: 'The hour-by-hour table',
  gridB: 'One row per line and order item, with a box for each hour. Pick the item from the order list so the description, colour and quantity come from Helinox; Total, Remain and Eff. are worked out for you.',
};
const ko = {
  vendorT: '업체 선택',
  vendorB: '특정 업체에 묶여 있지 않으므로, 생산량을 보거나 입력할 업체를 고르세요. 업체 계정은 자기 시트로 바로 들어갑니다.',
  dayT: '날짜 선택',
  dayB: '생산량은 하루 단위로 보관됩니다. 여기서 날짜를 바꾸고, 옆의 오늘 버튼은 오늘로 돌아가며, 입력된 시트는 시트가 있는 날을, 데이터 점검은 이상한 수치를 찾아 줍니다.',
  sumT: '하루 요약',
  sumB: '표에 보이는 항목의 수량, 행 수, 작업 시간 합계입니다. 열 필터가 켜져 있으면 그날의 일부만 합산됩니다.',
  toolsT: '수정, 미매칭, 새로고침',
  toolsB: '표 수정은 모든 셀을 입력 가능하게 열고(수정 권한이 있을 때) 한 번에 저장합니다. 미매칭은 주문과 연결되지 않은 행을 보여 주고, 새로고침은 그날을 다시 읽습니다.',
  gridT: '시간대별 표',
  gridB: '라인과 주문 항목마다 한 행이고 시간대별 입력칸이 있습니다. 주문 목록에서 항목을 고르면 설명, 색상, 수량이 Helinox 데이터에서 채워지며, 합계·잔량·효율은 자동 계산됩니다.',
};
const vi = {
  vendorT: 'Chọn vendor',
  vendorB: 'Tài khoản của bạn không gắn với một vendor, nên hãy chọn vendor cần xem hoặc nhập sản lượng. Tài khoản vendor vào thẳng sheet của mình.',
  dayT: 'Chọn ngày',
  dayB: 'Sản lượng lưu theo từng ngày. Đổi ngày ở đây; bên cạnh, Hôm nay quay về hôm nay, Sheet đã nhập liệt kê các ngày đã có sheet, còn Kiểm tra dữ liệu tìm các con số bất thường.',
  sumT: 'Tóm tắt trong ngày',
  sumB: 'Tổng số chiếc, số dòng và giờ làm của phần bảng đang hiện. Nếu đang lọc cột thì chỉ là một phần của ngày.',
  toolsT: 'Sửa, chưa khớp và tải lại',
  toolsB: 'Sửa bảng mở mọi ô để nhập (nếu bạn có quyền) và lưu một lượt. Chưa khớp liệt kê các dòng chưa gắn được vào đơn hàng. Tải lại đọc lại dữ liệu của ngày.',
  gridT: 'Bảng theo từng giờ',
  gridB: 'Mỗi line và mỗi mặt hàng trong đơn là một dòng, mỗi giờ có một ô. Chọn mặt hàng từ danh sách đơn để mô tả, màu và số lượng lấy từ Helinox; Total, Remain và Eff. tự tính.',
};
const zh = {
  vendorT: '选择供应商',
  vendorB: '你的账号没有绑定某一家供应商，请选择要查看或录入产量的供应商。供应商账号会直接进入自己的表。',
  dayT: '选择日期',
  dayB: '产量按天保存。在这里切换日期；旁边的“今天”可回到今天，“已填写的表”列出有记录的日期，“数据检查”会找出异常数字。',
  sumT: '当天概览',
  sumB: '表中当前显示内容的件数、行数和工作小时合计。如果开了列筛选，则只是当天的一部分。',
  toolsT: '编辑、未匹配与刷新',
  toolsB: '“编辑表格”会让所有单元格可输入（需有编辑权限）并一次保存。“未匹配”列出无法对应到订单的行。“刷新”重新读取当天数据。',
  gridT: '按小时的表格',
  gridB: '每条生产线和订单项一行，每个小时一个输入格。从订单列表中选择项目，描述、颜色和数量就来自 Helinox；Total、Remain 和 Eff. 自动计算。',
};
// French and Japanese (task #1173, 2026-11-04) — generated from `en`; a string not yet translated reads English.
const fr = {
  "vendorT": "Choisir le fournisseur",
  "vendorB": "Vous n'êtes pas lié à un seul fournisseur : choisissez celui dont vous voulez voir ou saisir la production. Un compte fournisseur accède directement à sa propre feuille.",
  "dayT": "Choisir le jour",
  "dayB": "La production est conservée jour par jour. Changez la date ici ; à côté, Aujourd'hui y revient, Feuilles remplies liste les jours qui ont une feuille, et Contrôle des données recherche les chiffres inhabituels.",
  "sumT": "La journée en un coup d'œil",
  "sumB": "Pièces, lignes et heures de travail totalisées pour ce que le tableau affiche. Avec un filtre de colonne actif, il ne s'agit que de cette partie de la journée.",
  "toolsT": "Modifier, non rapprochées et recharger",
  "toolsB": "Modifier le tableau ouvre toutes les cellules à la saisie (si vous pouvez modifier) et les enregistre ensemble. Non rapprochées liste les lignes qui n'ont pu être rattachées à une commande. Recharger relit la journée.",
  "gridT": "Le tableau heure par heure",
  "gridB": "Une ligne par ligne et par article de commande, avec une case pour chaque heure. Choisissez l'article dans la liste des commandes pour que la description, la couleur et la quantité viennent de Helinox ; Total, Reste et Eff. sont calculés pour vous."
};
const ja = {
  "vendorT": "仕入先を選択",
  "vendorB": "1社に限定されないため、出力を確認または入力したい仕入先を選んでください。仕入先アカウントは、自社のシートに直接移動します。",
  "dayT": "日付を選択",
  "dayB": "出力は1日ずつ保管されます。ここで日付を変更します。横の「今日」で今日に戻り、「入力済みシート」でシートのある日を一覧表示し、「データチェック」で異常な数字を探します。",
  "sumT": "1日をひと目で",
  "sumB": "表に表示されている分について、数量、行数、稼働時間を合計します。列フィルターが有効な場合は、その1日の一部のみの合計です。",
  "toolsT": "編集、未照合、再読み込み",
  "toolsB": "「表を編集」で（編集権限がある場合）すべてのセルが入力可能になり、まとめて保存します。「未照合」は注文に紐付けできなかった行を一覧表示します。「再読み込み」でその日を読み直します。",
  "gridT": "時間ごとの表",
  "gridB": "ラインと注文アイテムごとに1行で、各時間に入力欄があります。注文リストからアイテムを選ぶと、説明、カラー、数量が Helinox から取得されます。「合計」「残」「効率」は自動計算されます。"
};

const dictionary = { ns: 'tourOutput', en, ko, vi, zh, fr, ja };
export default dictionary;
